import { Helmet } from "react-helmet";
// Data
import { publicRoutesDataTranslation } from "data/routes/publicRoutesDataTranslation";
// Hooks
import { useLanguagesContext } from "hooks/useContextAll";
// Views
import PageNotFoundView from "views/public/404/PageNotFoundView";
import AboutView from "views/public/about/AboutView";
import ContactView from "views/public/contact/ContactView";
import HomeView from "views/public/home/HomeView";
import ServicesView from "views/public/services/ServicesView";
import MeView from "views/public/me/MeView";

const entranceAnimation = "animate-fade-up";

export const Home = () => {
    return (
        <div id="home">
            <Helmet>
                <title>Yozu</title>
            </Helmet>
            <HomeView />
        </div>
    );
};

export const About = () => {
    const currentLanguage = useLanguagesContext().language;
    return (
        <div className="container">
            <div id="about" className={entranceAnimation}>
                <Helmet>
                    <title>
                        {publicRoutesDataTranslation.about[currentLanguage]}
                    </title>
                </Helmet>
                <AboutView />
            </div>
        </div>
    );
};

export const Services = () => {
    const currentLanguage = useLanguagesContext().language;
    return (
        <div className="container">
            <div id="services" className={entranceAnimation}>
                <Helmet>
                    <title>
                        {publicRoutesDataTranslation.services[currentLanguage]}
                    </title>
                </Helmet>
                <ServicesView />
            </div>
        </div>
    );
};

export const Contact = () => {
    const currentLanguage = useLanguagesContext().language;
    return (
        <div className="container">
            <div id="contact" className={entranceAnimation}>
                <Helmet>
                    <title>
                        {publicRoutesDataTranslation.contact[currentLanguage]}
                    </title>
                </Helmet>
                <ContactView />
            </div>
        </div>
    );
};

export const PageNotFound = () => {
    return (
        <div className="container">
            <div id="page-not-found">
                <Helmet>
                    <title>Opps&#10071;</title>
                </Helmet>
                <PageNotFoundView />
            </div>
        </div>
    );
};

export const Me = () => {
    return (
        <div className="container">
            <div id="me">
                <Helmet>
                    <title>Yozu</title>
                </Helmet>
                <MeView />
            </div>
        </div>
    );
};
